import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Paper,
  Box,
  Button,
  Divider,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import WifiIcon from '@mui/icons-material/Wifi';
import AccessibleIcon from '@mui/icons-material/Accessible';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import NatureIcon from '@mui/icons-material/Nature';
import SmartphoneIcon from '@mui/icons-material/Smartphone';

export const ChronicleModernization = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/chronicles')}
        sx={{ mb: 3 }}
      >
        Zurück zur Chronik
      </Button>

      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#E30613' }}>
          Moderne Flotte und Technologie
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          2010-2020: Innovation im öffentlichen Nahverkehr
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Das zweite Jahrzehnt des 21. Jahrhunderts brachte für DB Regio Bus Mitte eine 
          Zeit der technologischen Revolution. Digitalisierung, Umweltbewusstsein und 
          Kundenorientierung prägten diese Ära der Modernisierung.
        </Typography>

        <Card sx={{ my: 3, backgroundColor: '#f0f8ff' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="primary">
              Technologische Innovationen
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <GpsFixedIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Echtzeit-Fahrgastinformation"
                  secondary="Moderne GPS-Systeme ermöglichen präzise Ankunftszeiten"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <WifiIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="WLAN in Bussen"
                  secondary="Kostenloses Internet für Fahrgäste ab 2015"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <SmartphoneIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Mobile Ticketing"
                  secondary="Fahrkartenkauf per Smartphone-App"
                />
              </ListItem>
            </List>
          </CardContent>
        </Card>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Ein besonderer Schwerpunkt lag auf der Verbesserung der Barrierefreiheit. 
          Alle neuen Fahrzeuge wurden mit Niederflurtechnik, Rollstuhlplätzen und 
          akustischen Ansagen ausgestattet, um Menschen mit Behinderungen den Zugang 
          zum öffentlichen Verkehr zu erleichtern.
        </Typography>

        <Card sx={{ my: 3, backgroundColor: '#f0fff0' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom color="success.main">
              Umwelt und Nachhaltigkeit
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <NatureIcon color="success" />
                </ListItemIcon>
                <ListItemText 
                  primary="Euro 6-Motoren"
                  secondary="Drastische Reduzierung der Schadstoffemissionen"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ElectricBoltIcon color="success" />
                </ListItemIcon>
                <ListItemText 
                  primary="Hybrid- und Elektrobusse"
                  secondary="Erste Testfahrzeuge ab 2018"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <AccessibleIcon color="success" />
                </ListItemIcon>
                <ListItemText 
                  primary="100% Barrierefreiheit"
                  secondary="Vollständige Flottenerneuerung bis 2020"
                />
              </ListItem>
            </List>
          </CardContent>
        </Card>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Die Einführung der RMV-App revolutionierte die Art, wie Fahrgäste mit dem 
          öffentlichen Verkehr interagieren. Echtzeitinformationen, Routenplanung 
          und mobile Fahrkarten wurden zu Standardfunktionen, die von den Kunden 
          sehr geschätzt wurden.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
          Diese Dekade war auch geprägt von ersten Experimenten mit alternativen 
          Antrieben. DB Regio Bus Mitte testete Hybrid- und Elektrobusse und 
          sammelte wichtige Erfahrungen für die Elektrifizierung der Flotte in 
          den folgenden Jahren.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Card sx={{ backgroundColor: '#e3f2fd' }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Quellen:
            </Typography>
            <Typography variant="body2" component="div">
              • Deutsche Bahn AG: Digitalisierungsstrategie DB 4.0 (2015)<br />
              • RMV: "10 Jahre RMV-App" - Erfolgsbilanz (2020)<br />
              • VDV-Statistik: Entwicklung der Barrierefreiheit im ÖPNV<br />
              • Bundesumweltamt: "Elektromobilität im ÖPNV" (2018-2020)<br />
              • DB Nachhaltigkeitsberichte 2015, 2018, 2020
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    </Container>
  );
};

export default ChronicleModernization;